import { Commit } from 'vuex';

interface LoadingState {
	loading: boolean;
	globalRefresh: boolean;
}

export default {
	namespaced: true,
	state: {
		loading: false,
		globalRefresh: false,
	} as LoadingState,

	getters: {
		getLoadingStatus: (state: LoadingState): boolean => {
			return state.loading;
		},
		getGlobalRefresh: (state: LoadingState): boolean => {
			return state.globalRefresh;
		},
	},

	mutations: {
		CHANGE_LOADING_STATUS(state: LoadingState): void {
			state.loading = !state.loading;
		},
		CHANGE_GLOBAL_STATUS(state: LoadingState): void {
			state.globalRefresh = !state.globalRefresh;
		},
	},

	actions: {
		changeLoadingStatus({ commit }: { commit: Commit }): void {
			commit('CHANGE_LOADING_STATUS');
		},
		changeGlobalStatus({ commit }: { commit: Commit }): void {
			commit('CHANGE_GLOBAL_STATUS');
		},
	},
};
